// extracted by mini-css-extract-plugin
module.exports = {"HomeLogo":"HomeLogo_HomeLogo__1pyKv"};